<template>
  <component :is="tag" :class="classes" :style="containerStyle">
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { flexProps } from './flex'
import { useFlex } from './use-flex'

defineOptions({
  name: 'JdFlex',
})

const props = defineProps(flexProps)

const { classes, containerStyle } = useFlex(props)
</script>
